import Styled from 'styled-components'

export const Button = Styled.button`
    width: ${props => props.width ? props.width : '100%'} !important;
    color: ${props => props.outline ? '#050922' : '#FFFFFF'};
    background-color: ${props => props.outline ? 'transparent' : '#050922'};
    width: 100%;
    height: 40px;
    border: 1px solid #050922;
    border-radius: 9px;
    
    display: flex;
    align-items: center;
    justify-content: center;
   
`
